import { ReactComponent as EmailIcon } from 'assets/Icons/Email.svg'
import { ReactComponent as AppleIcon } from 'assets/Icons/Apple.svg'
import { ReactComponent as GoogleIcon } from 'assets/Icons/Google.svg'
import { ReactComponent as FacebookIcon } from 'assets/Icons/Facebook.svg'
import { useContent } from 'lib/content/react'
import { IdentityProvider } from 'types/entities/IdentityProvider'

const useIdentityProviders = () => {
  const { formatMessage } = useContent()

  const providers: IdentityProvider[] = [
    {
      id: 'google',
      label: formatMessage({ id: 'pmportal.login.google' }),
      icon: <GoogleIcon />,
      clickEvent: 'PORTAL_SIGNIN_GOOGLE',
    },
    {
      id: 'facebook',
      label: formatMessage({ id: 'pmportal.login.facebook' }),
      icon: <FacebookIcon />,
      clickEvent: 'PORTAL_SIGNIN_FACEBOOK',
    },
    {
      id: 'apple',
      label: formatMessage({ id: 'pmportal.login.apple' }),
      icon: <AppleIcon />,
      clickEvent: 'PORTAL_SIGNIN_APPLE',
    },
    {
      id: 'email',
      label: formatMessage({ id: 'pmportal.login.email' }),
      icon: <EmailIcon />,
      clickEvent: 'PORTAL_SIGNIN_EMAIL',
    },
  ]

  return { providers }
}

export default useIdentityProviders
